export const getProgressColor = (value: number) =>
  value < 3 ? '#EE3D3D' : value < 4.9 ? '#FCBD26' : '#4EDA9D';
